import React, { useState, useEffect } from "react";
import "./ClassRooms.scss";

import img from "../../assets/Infrastructure/Class Rooms/img (1).jpeg";
import img1 from "../../assets/Infrastructure/Class Rooms/img (2).jpeg";
import img2 from "../../assets/Infrastructure/Class Rooms/img (3).jpeg";
import img3 from "../../assets/Infrastructure/Class Rooms/img (4).jpeg";
import img4 from "../../assets/Infrastructure/Class Rooms/img (5).jpeg";
import img5 from "../../assets/Infrastructure/Class Rooms/img (6).jpeg";

const images = [img, img1, img2, img3, img4, img5];

const ClassRooms = () => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="classrooms">
      <div className="container">
        <h1 className="page-title">CLASS ROOMS</h1>

        {/* IMAGE CAROUSEL */}
        <div className="classroom-carousel">
          {images.map((img, index) => (
            <div
              key={index}
              className={`slide ${index === current ? "active" : ""}`}
            >
              <img src={img} alt={`Class Room ${index + 1}`} />
            </div>
          ))}
        </div>

        {/* CONTENT */}
        <div className="content-card">
          <p className="intro">
           Our classrooms are designed to foster engaging and interactive learning, spacious and well-ventilated, class rooms provide an ideal environment for academic excellence with comfortable seating and ample space, students can focus on their studies and engage with peers and faculty.
          </p>

          <p className="intro">
            Class rooms are spacious with natural light and ventilation, supportive and interactive learning environment.
          </p>

          
        </div>
      </div>
    </section>
  );
};

export default ClassRooms;
